import React, { useState, useContext, useEffect, useRef } from "react";
import axios from "../../../../../axios/index";

import { useHistory, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import PersianNumberToString from "persian-number-tostring";

// Context
import { UserContext } from "../../../../Context/UserContextProvider";

//Styles
import styles from "../../../DashboardReuseAbleComponents/AddNewFile.module.css";
import Dstyles from "../../../DashboardFileManagement/DashboardFileManagement.module.css";
import "react-toastify/dist/ReactToastify.css";

// Re Useable Components
import AddNewFileDropdown from "../../../DashboardReuseAbleComponents/AddNewFiles/AddNewFileDropdown";
import DashboardHeader from "../../../DashboardReuseAbleComponents/DashboardHeader";
import DashboardSideMenu from "../../../DashboardReuseAbleComponents/DashboardSideMenu";
import { removeCommas } from "@persian-tools/persian-tools";
import { Editor } from "@tinymce/tinymce-react";
import ShowProfileModal from "../ShowProfileModal";
import NewFilesConsultantSelect from "../../../DashboardReuseAbleComponents/AddNewFiles/NewFilesConsultantSelect";
import Checkbox from "@mui/material/Checkbox";

//images
import arrowIcon from "../../../../../assets/img/DashboardICons/ArrowRounded.svg";
import Images from "./Images";
import { EditCardRegionValidate } from "./EditCardRegionValidate";

const EditCardRegion = props => {
  const { state } = useLocation();
  const history = useHistory();
  let currentDate = new Date().toLocaleDateString("fa-IR");
  const { userToken, userData, permissions } = useContext(UserContext);
  const userRole = permissions?.find(item => item === 15) === 15 ? "IsSuperUser" : "IsConsultant";
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loadedImages, setLoadeImages] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [images, setImages] = useState([]);

  const [fileData, setFileData] = useState({
    title: "",
    link: "",
    startPrice: "",
    endPrice: "",
    currency: "",
    description: "",
    fileConsultant: [],
    seoTitle: "",
    seoDescription: "",
    seoKeywords: "",
    seoIndexPage: false,
    seoCanonical: "",
    seoSchema: "",
    region: "",
    fileConsultantID: "",
  });
  const description = useRef(null);

  useEffect(() => {
    const getData = async () => {
      const getEditData = await axios.get(`Estate/bySlugAdmin/${state.state.slug}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      const editedData = getEditData.data.data;
      setFileData(prev => {
        return {
          ...prev,
          title: editedData.title,
          description: editedData.description,
          fileConsultantID: editedData?.userId,
          seoTitle: editedData.seoData.metaTitle,
          seoDescription: editedData.seoData.metaDescription,
          seoKeywords: editedData.seoData.metaKeyWords,
          seoIndexPage: editedData.seoData.indexPage,
          seoCanonical: editedData.seoData.canonical,
          seoSchema: editedData.seoData.schema,
          region: editedData.estateRegion,
          currency: editedData.estatePriceType,
          link: editedData.otherSiteUrl,
          startPrice: editedData.priceFrom,
          endPrice: editedData.toPrice,
        };
      });
      setLoadeImages(editedData.images);

      setIsLoading(false);
    };
    getData();
  }, [state, userToken]);

  useEffect(() => {
    setErrors(EditCardRegionValidate(fileData, images, userRole));
  }, [fileData, images, userRole]);

  const addCommas = num => num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const removeNonNumeric = num => num?.toString().replace(/[^0-9]/g, "");

  return (
    <>
      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <div className={`mt-3 px-0 ${Dstyles.container}`}>
                <DashboardHeader onClick={() => setModalShow(true)} />
                <div className={`px-0 ${Dstyles.container}`}>
                  {/* Type Header start */}
                  <div className="py-2">
                    <div className="container-fluid">
                      <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center ms-md-5 ms-0 mt-3" dir="rtl">
                        <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2 ">
                          <a href="#" onClick={history.goBack}>
                            <img className="ms-2 pointer" src={arrowIcon} alt="icon" />
                          </a>
                          <div className={Dstyles.text1}>فروش ملک در خارج از کشور</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Type Header end */}

                  {/* title input start */}
                  <div className="py-2">
                    <div className="container-fluid">
                      <div className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3`} dir="rtl">
                        <div className="w-100 d-flex justify-content-between align-items-start mb-4">
                          <div className="w-100 d-flex align-items-start justify-content-center flex-column ms-2">
                            <div className={`mb-3 ${styles.input_header}`}>عنوان</div>
                            <input
                              type="text"
                              name="title"
                              value={fileData.title}
                              onChange={changeHandler}
                              className={`w-100 bg-light py-2 pe-3 ${styles.input}`}
                              placeholder="مثلا آپارتمان ۳۰۰ متر تختی"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* title input end */}

                  {/* src Link */}
                  <div className="py-2">
                    <div className="container-fluid">
                      <div className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3`} dir="rtl">
                        <div className="w-100 d-flex justify-content-between align-items-start mb-4">
                          <div className="w-100 d-flex align-items-start justify-content-center flex-column ms-2">
                            <div className={`mb-3 ${styles.input_header}`}>لینک فایل</div>
                            <input
                              type="link"
                              name="link"
                              value={fileData.link}
                              onChange={changeHandler}
                              className={`w-100 bg-light py-2 pe-3 ${styles.input}`}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* src Link */}

                  {/* sub menus row1 */}
                  <div className="d-flex align-items-center justify-content-md-between justify-content-center mt-2 mb-3 flex-wrap">
                    <div className="d-flex flex-column justify-content-center align-items-start mb-md-0 mb-3 px-md-4 px-0" dir="rtl">
                      <div className={`mb-3 ${styles.input_header}`}>قیمت پایان</div>
                      <label className="position-relative" htmlFor="endPrice">
                        <span className={styles.input_left_text}>تومان</span>
                        <input
                          type="text"
                          name="endPrice"
                          value={addCommas(removeNonNumeric(fileData.endPrice))}
                          onChange={priceHandler}
                          className={`bg-light py-2 ps-5 pe-2 ${styles.input_meter}`}
                          style={{ textAlign: "right" }}
                        />
                      </label>
                      <span className={styles.number_farsi}>{PersianNumberToString(parseInt(fileData.endPrice ? fileData.endPrice : 0))} تومان</span>
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-start mb-md-0 mb-3 px-md-4 px-0" dir="rtl">
                      <div className={`mb-3 ${styles.input_header}`}>قیمت شروع</div>
                      <label className="position-relative" htmlFor="startPrice">
                        <span className={styles.input_left_text}>تومان</span>
                        <input
                          type="text"
                          name="startPrice"
                          value={addCommas(removeNonNumeric(fileData.startPrice))}
                          onChange={priceHandler}
                          className={`bg-light py-2 ps-5 pe-2 ${styles.input_meter}`}
                          style={{ textAlign: "right" }}
                        />
                      </label>
                      <span className={styles.number_farsi}>{PersianNumberToString(parseInt(fileData.startPrice ? fileData.startPrice : 0))} تومان</span>
                    </div>
                    <AddNewFileDropdown regionName={fileData.region} userAdd={false} setDropDownsData={setFileData} region country />
                  </div>
                  {/* sub menus row1 */}

                  {/* sub menus row 2 */}
                  <AddNewFileDropdown currencyName={fileData.currency} setDropDownsData={setFileData} currency />
                  {/* sub menus row 2 */}

                  {/* upload img */}
                  <Images
                    images={images}
                    setImages={setImages}
                    loadedImages={loadedImages}
                    setLoadeImages={setLoadeImages}
                    deleteImgHandler={deleteImgHandler}
                  />
                  {/* upload img */}

                  {permissions?.find(item => item === 15) === 15 && (
                    <NewFilesConsultantSelect state={userData} fileData={fileData} setFileData={setFileData} editedData={true} />
                  )}

                  {/* Description */}
                  <div className="py-2">
                    <div className="container-fluid">
                      <div className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3`} dir="rtl">
                        <div className="w-100 d-flex flex-column justify-content-center align-items-start mb-4">
                          <div className={`mb-3 ${styles.input_header}`}>توضیحات</div>
                          <Editor
                            tinymceScriptSrc={`${process.env.PUBLIC_URL}/assets/tinymce/tinymce.min.js`}
                            onInit={(evt, editor) => (description.current = editor)}
                            initialValue={fileData.description}
                            init={{
                              height: 350,
                              width: "100%",
                              menubar: true,
                              resize: false,
                              directionality: "rtl",
                              plugins: [
                                "advlist",
                                "autolink",
                                "lists",
                                "link",
                                "anchor",
                                "code",
                                "charmap",
                                "preview",
                                "anchor",
                                "searchreplace",
                                "visualblocks",
                                "fullscreen",
                                "insertdatetime",
                                "table",
                                "help",
                                "wordcount",
                              ],
                              toolbar:
                                "undo redo | casechange blocks | bold italic backcolor | " +
                                "alignleft aligncenter alignright alignjustify | " +
                                "bullist numlist checklist outdent indent | removeformat | a11ycheck code table help",
                              content_style: "body { font-family:Vazir,Arial,sans-serif; font-size:14px, direction:rtl }",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Description */}

                  {/* SEO DATA */}
                  {userRole === "IsSuperUser" && (
                    <div className="py-2 mb-3">
                      <div className="container-fluid">
                        <div className="w-100 d-flex justify-content-md-start justify-content-center flex-wrap align-items-center mt-3 me-3" dir="rtl">
                          <div className="w-100 d-flex flex-column justify-content-center align-items-start flex-wrap">
                            <div className={`mb-4 ${styles.title_bold}`}>اطلاعات مربوط به سئو</div>
                            <div className="w-100 d-flex flex-column align-items-center justify-content-center">
                              <div className="w-100 d-flex justify-content-center align-items-center ms-md-2 mb-md-0 my-2">
                                <div
                                  className={`d-flex flex-column justify-content-center align-items-start ms-md-2 mb-md-0 my-2 ${styles.input__container_half}`}>
                                  <div className={`my-3 ${styles.input_header}`}>seoTitle</div>
                                  <input
                                    type="text"
                                    name="seoTitle"
                                    value={fileData.seoTitle}
                                    onChange={changeHandler}
                                    className={`bg-light py-2 ps-5 pe-2 w-100 ${styles.input_meter}`}
                                    style={{ textAlign: "right" }}
                                  />
                                </div>
                                <div
                                  className={`d-flex flex-column justify-content-center align-items-start ms-md-2 mb-md-0 my-2 ${styles.input__container_half}`}>
                                  <div className={`my-3 ${styles.input_header}`}>seoKeywords</div>
                                  <input
                                    type="text"
                                    name="seoKeywords"
                                    value={fileData.seoKeywords}
                                    onChange={changeHandler}
                                    className={`bg-light py-2 ps-5 pe-2 w-100 ${styles.input_meter}`}
                                    style={{ textAlign: "right" }}
                                  />
                                </div>
                              </div>

                              <div className="w-100 d-flex flex-column justify-content-center align-items-start me-md-2 mt-md-0 my-2">
                                <div className={`my-3 ${styles.input_header}`}>seoDescription</div>
                                <textarea
                                  name="seoDescription"
                                  value={fileData.seoDescription}
                                  onChange={changeHandler}
                                  className={`bg-light py-3 ps-5 pe-3 w-100  ${styles.text__area}`}></textarea>
                              </div>

                              <div className="w-100 d-flex flex-column justify-content-center align-items-start me-md-2 mt-md-0 my-2">
                                <div className={`my-3 ${styles.input_header}`}>seoSchema</div>
                                <textarea
                                  name="seoSchema"
                                  value={fileData.seoSchema}
                                  onChange={changeHandler}
                                  className={`bg-light py-3 ps-5 pe-3 w-100  ${styles.text__area}`}></textarea>
                              </div>

                              <div className="w-100 d-flex flex-column justify-content-center align-items-start me-md-2 mt-md-0 my-2">
                                <div className={`my-3 ${styles.input_header}`}>seoCanonical</div>
                                <input
                                  type="text"
                                  name="seoCanonical"
                                  value={fileData.seoCanonical}
                                  onChange={changeHandler}
                                  className={`bg-light py-2 ps-5 pe-2 w-100 ${styles.input_meter}`}
                                  style={{ textAlign: "right" }}
                                />
                              </div>

                              <div className="w-100 d-flex flex-column align-items-start justify-content-center mb-4">
                                <div className={`my-3 ${styles.input_header}`}>seoIndexPage</div>
                                <Checkbox
                                  checked={fileData.seoIndexPage}
                                  id="seoIndexPage"
                                  onClick={changeHandler}
                                  inputProps={{ "aria-label": "controlled" }}
                                  size="medium"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* SEO DATA */}

                  {/* Save Btn */}
                  <div className="py-2 mb-4">
                    <div className="container-fluid">
                      <div className={`d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3`} dir="rtl">
                        <div className="w-100 d-flex align-items-center justify-content-md-end justify-content-center">
                          {btnLoader ? (
                            <div className={styles.btn_loader_container}>
                              <div className={styles.btn_spinner}></div>
                            </div>
                          ) : (
                            <button className={`d-flex align-items-center justify-content-center ${styles.save_btn}`} type="submit" onClick={submitHandler}>
                              ذخیره
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Save Btn */}
                </div>
              </div>
            </div>
            <div className="col-md-3">
              {/* sideMenu starts */}
              <DashboardSideMenu addNewFileRegion />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );

  function changeHandler(event) {
    if (event.target.name === "slug") {
      let value = event.target.value;
      value = value.replace(/[^A-Za-z-0-9]/gi, " ");
      setFileData(prev => {
        return { ...prev, slug: value };
      });
    } else if (event.target.name === "ownersPhone") {
      if (event.target.value === "" || event.target.value.match(/^[0-9]+$/)) {
        if (event.target.value.length <= 11) {
          setFileData(prev => {
            return { ...prev, [event.target.name]: event.target.value };
          });
        }
      }
    } else if (event.target.id === "seoIndexPage") {
      setFileData(prev => {
        return { ...prev, seoIndexPage: event.target.checked };
      });
    } else if (event.target.name === "Radio") {
      setFileData(prev => {
        return { ...prev, fileFound: event.target.value };
      });
    } else {
      setFileData(prev => {
        return { ...prev, [event.target.name]: event.target.value };
      });
    }
  }

  function priceHandler(event) {
    setFileData(prev => {
      return { ...prev, [event.target.name]: removeCommas(event.target.value) };
    });
  }

  function submitHandler() {
    const inputData = fileData.link;
    const seoCanonical = fileData.seoCanonical;
    const linkRegex = /^(http|https):\/\/[^ "]+$/;
    if (inputData && !linkRegex.test(inputData)) {
      notify("لینک را به درستی وارد نمایید", "error");
    } else if (seoCanonical && !linkRegex.test(seoCanonical)) {
      notify("باید لینک باشد seoCanonical", "error");
    } else {
      if (!Object.keys(errors).length) {
        notify("درحال ایجاد فایل جدید", "success");
      } else {
        notify("!لطفا تمام فیلد هارا پرکنید", "error");
      }
    }
  }

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      selectPostFunctionHandler();
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }

  function selectPostFunctionHandler() {
    postHandler();
  }

  async function deleteImgHandler(item) {
    const data = {
      imageId: item.id,
      estateId: item.estateId,
    };
    const postDeleteImg = await axios.post("Estate/removeImage", data, {
      headers: { authorization: "Bearer " + userToken },
    });
  }

  async function postHandler() {
    const p2e = s => s?.toString()?.replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

    setBtnLoader(true);
    try {
      // Object destructuring for fileData properties
      const { title, link, fileConsultant, region, startPrice, endPrice, currency, fileConsultantID } = fileData;
      var data = new FormData();
      data.append("EstateId", state.state.id);
      data.append("UserId", fileConsultant[0].id ? fileConsultant[0].userId : fileConsultantID);
      data.append("Title", title);
      data.append("PriceFrom", startPrice);
      data.append("ToPrice", endPrice);
      data.append("OtherSiteUrl", link);
      if (typeof currency === "number") {
        data.append("EstatePriceType", currency);
      } else {
        data.append(
          "EstatePriceType",
          currency == "تومان" ? p2e("1") : currency == "لیر" ? p2e("2") : currency == "دلار" ? p2e("3") : currency == "پوند" && p2e("4")
        );
      }
      if (typeof region === "number") {
        data.append("EstateRegion", region);
      } else {
        data.append("EstateRegion", region == "ایران" ? "1" : region == "ترکیه" ? "2" : region == "قبرس" && "3");
      }
      data.append("ConstructionDate", currentDate?.toString());
      data.append("Meterage", 1);
      data.append("RoomCount", 1);
      data.append("Floor", 1);
      data.append("RentPrice", 0);
      data.append("ExchangeDescription", "");
      data.append("TotalPrice", 1);
      data.append("MeteragePrice", 1);
      data.append("MortgagePrice", 0);
      data.append("Description", description.current.getContent() ? description.current.getContent() : "");
      data.append("CategoryId", "272");
      data.append("SubCategoryId", "271");
      data.append("UnitsNumber", 1);
      data.append("Facilities", "");
      if (loadedImages != "") {
        data.append("ImageFile", loadedImages == "" ? images[0].file : loadedImages[0].imageFileUrl);
      } else {
        data.append("ImageFile", images == undefined ? "" : images[0].file);
      }
      data.append("ConstructionYear", "1399");
      data.append("Commission", 1);
      data.append("SearchType", 1);
      data.append("Address.Province", "region");
      data.append("Address.Location", "region");
      data.append("Address.City", "region");
      data.append("Address.Zone", "region");
      data.append("Address.ShortAddress", "region");
      data.append("Address.FullAddress", "region");
      data.append("CustomKeys", "تعداد پارکینگ");
      data.append("CustomValues", "0");
      data.append("Keys", [136]);
      data.append("SeoDataViewModel.MetaTitle", fileData.seoTitle ? fileData.seoTitle : "آذرملک");
      data.append("SeoDataViewModel.MetaDescription", fileData.seoDescription ? fileData.seoDescription : "آذرملک");
      data.append("SeoDataViewModel.MetaKeyWords", fileData.seoKeywords ? fileData.seoKeywords : "آذرملک");
      data.append("SeoDataViewModel.IndexPage", fileData.seoIndexPage ? fileData.seoIndexPage : false);
      data.append("SeoDataViewModel.Canonical", fileData.seoCanonical ? fileData.seoCanonical : "http://azrmelk.com/");
      data.append("SeoDataViewModel.Schema", fileData.seoSchema ? fileData.seoSchema : "آذرملک");
      data.append("Area", "1");
      data.append(
        "EsateInfos",
        JSON.stringify({
          fullName: "پویا موسایی",
          phoneNumber: "9370307748",
          responsibility: "تست",
        })
      );
      data.append("Values", "شرقی");

      if (images) {
        try {
          for (const image of images) {
            var imageData = new FormData();
            imageData.append("EstateId", state.state.id);
            imageData.append("ImageFile", image.file);
            const postImg = await axios.post("Estate/addImage", imageData, {
              headers: { authorization: "Bearer " + userToken },
            });
          }
        } catch (error) {}
      }
      const apiData = await axios.put("Estate/EditEstateForAdmin", data, {
        headers: { authorization: "Bearer " + userToken },
      });

      // console.log(apiData)
      setBtnLoader(false);
      history.push("/FileManagement");
    } catch (error) {
      // console.log(error)
      notify("خطای سرور", "error");
    }
  }
};

export default EditCardRegion;
